changeActiveFaq = function (id) {
    let list = 'list-item'
    let type = 'active-item'
    for(let i=1;i<=3;i++){
        document.getElementById(list+i).classList.remove('active')
        document.getElementById(type+i).classList.remove('active')
    }
    document.getElementById(list+id).classList.add('active')
    document.getElementById(type+id).classList.add('active')
}

changeActiveTip = function(id) {
    let list = 'a'
    let type = 'a-tab'
    for(let i=1;i<=5;i++){
        document.getElementById(i+list).classList.remove('active')
        document.getElementById(i+type).classList.remove('active')
    }
    document.getElementById(id+list).classList.add('active')
    document.getElementById(id+type).classList.add('active')
    trackEvent({
        name: 'ctr_help_landing',
        type: 'Page'
    })
}
